var _rect;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYellowSquareTilted = function SvgYellowSquareTilted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.757,
    height: 80.757
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 122",
    width: 64.152,
    height: 64.152,
    rx: 3,
    transform: "rotate(-17.89 62.601 9.854)",
    fill: "rgba(255,222,140,0.2)"
  })));
};
export { SvgYellowSquareTilted as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MC43NTciIGhlaWdodD0iODAuNzU3IiB2aWV3Qm94PSIwIDAgODAuNzU3IDgwLjc1NyI+DQogIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTIyIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxMjIiIHdpZHRoPSI2NC4xNTIiIGhlaWdodD0iNjQuMTUyIiByeD0iMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxOS43MDcpIHJvdGF0ZSgtMTcuODkpIiBmaWxsPSJyZ2JhKDI1NSwyMjIsMTQwLDAuMikiLz4NCjwvc3ZnPg0K";